import React from 'react';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import content from '../../content';
import './Footer.css';

const { footer } = content;

const icons = {
  email: FaEnvelope,
  linkedin: FaLinkedin,
  github: FaGithub,
};

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>{footer.copyright}</p>
        {footer.links.length > 0 && (
          <ul className="social-links">
            {footer.links.map((link) => {
              const Icon = icons[link.icon];
              const isExternal = link.href.startsWith('http');
              return (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="contact-link"
                    {...(isExternal
                      ? { target: '_blank', rel: 'noopener noreferrer' }
                      : {})}
                  >
                    {Icon && <Icon size={20} />} {link.label}
                  </a>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </footer>
  );
}

export default Footer;
